<template>
  <!--头部开始-->
  <div style="height: 72px;">
    <el-header class="home-header" style="height:72px;padding: 0px;
    display: flex;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;" v-if="ismobile === false">
      <!--中部开始-->
      <!-- pc版本 -->
      <div class="home-header-middle" style="justify-content: space-between;">
        <!--左侧logo 开始-->
        <div class="grid-content bg-purple home-left-logo">
          <img class="home-img" src="/static/img/logo-long.png" style="cursor:pointer;" @click="gotoHome">
        </div>
        <!--左侧logo 结束-->
        <!--跳转地址 开始-->
        <!-- <div class="home-header-center">
          <div onclick="window.location.href='https://www.hibeds.com/products'">Products</div>
          <div>Technology</div>
          <div>Services</div>
          <div>About us</div>
        </div> -->
        <!--跳转地址 结束-->
        <!--右侧按钮 开始-->
        <div class="home-button">
          <!-- <div>Sign up</div> -->
          <div style="color:#fff;" @click="gotoSignUp">Sign up</div>
          <div style="background-color: #fff; " @click="gotoSignIn">Sign in</div>
          <div style="color:#fff;" @click="gotoHome">Contact us</div>
        </div>
        <!--右侧按钮 结束-->
      </div>
    </el-header>
    <el-header class="home-header" style="height:72px;padding: 0px;
    display: flex;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    width: 100%;" v-else>
      <!--中部开始-->
      <!-- 手机端版本 -->
      <div class="home-header-middle" style="justify-content: space-between;width: 90%;padding: 0 5%;">
        <!--左侧logo 开始-->
        <div class="grid-content bg-purple home-left-logo">
          <img class="home-img" @click="gotoHome" src="/static/img/logo-long.png" style="cursor:pointer;">
        </div>
        <!--左侧logo 结束-->
        <!--右侧按钮 开始-->
        <div class="home-button" style="float: right;">
          <!-- <div>Sign up</div> -->
          <img alt="menu" :src="homeImg" @click="showHomeMenu" style=" width: 28px; height: 28px;">
        </div>
        <!--右侧按钮 结束-->
      </div>
    </el-header>
    <!-- 手机端 menu-->
    <el-drawer title="" :visible.sync="homeMenu" :modal-append-to-body="false" size="100%" class="alert-menu" :with-header="false" >
      <el-row class="right-menu-title" style=" --tw-bg-opacity: 1; background-color: rgb(255 255 255 / var(--tw-bg-opacity));">
        <el-col :span="24">
          <div class="home-header-button" style="color:#fff;background-color: #2A6FF8; " @click="gotoSignUp">Sign up</div>
          <div class="home-header-button" style="color: #2A6FF8;background-color: #fff; margin: 16px auto;" @click="gotoSignIn">Sign in</div>
          <div class="home-header-button" style="color:#fff;background-color: #2A6FF8; " @click="gotoHome">Contact us</div>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
  <!--头部结束-->
</template>

<script>
export default {
  name: 'publicHomeHeader',
  data () {
    return {
      ismobile: false,
      homeImg: 'https://res.roompai.com/homeStatic/menu-svgrepo-com.svg',
      homeMenu: false
    }
  },
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
  },
  methods: {
    gotoHome: function () {
      window.location.href = 'https://www.hibeds.com'
    },
    gotoSignUp: function () {
      this.$router.push({name: 'register'})
    },
    gotoSignIn: function () {
      this.$router.push({name: 'login'})
    },
    showHomeMenu: function () {
      if (this.homeMenu === false) {
        this.homeMenu = true
        this.homeImg = 'https://res.roompai.com/homeStatic/x-svgrepo-com.svg'
      } else {
        this.homeMenu = false
        this.homeImg = 'https://res.roompai.com/homeStatic/menu-svgrepo-com.svg'
      }
    }
  }
}
</script>

<style scoped>
  /deep/ .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner,.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{border-color:rgba(83, 102, 163, 1) !important;box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
  /deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;}
  .button-search{margin-top: 0 0 0 15px !important; width: 100px !important; float: none !important;}
  .lineheight{line-height: 36px;}
  .header{padding:0px;}
  .menu-height-5{height:5px;}
  .menu-height-15{height:15px;}
  .border-bottom-solid{border-bottom:solid 1px #ccc;}
  .alert-menu{font-family: PingFangSCRegular, 'PingFang SC', sans-serif; margin-top: 72px;}
  .right-menu-Tips{height:45px;line-height:45px;font-size: 13px;margin: 0px 25px;overflow:hidden;}
  .right-menu-title{height:55px;line-height:55px;font-size: 15px;margin: 0px 25px;}
  .right-menu-title button{width: 100%;height: 45px;border-radius: 3px;border: solid 1px rgba(79, 76, 76, 1);background:rgba(79, 76, 76, 1);color:white;box-shadow: 0 4px 5px 1px #ccc;font-size: 15px;overflow:hidden;}
  .right-menu{margin: 0px 25px;margin-bottom: 10px;height:35px;line-height:35px;font-size: 16px;}
  .right-menu .menu-language{background:url(/static/img/menu/language.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-currency{background:url(/static/img/menu/currency.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-faq{background:url(/static/img/menu/FAQ.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-privacyPolicy{background:url(/static/img/menu/privacyPolicy.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-termsOfUse{background:url(/static/img/menu/termsOfService.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-aboutUs{background:url(/static/img/menu/aboutUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-contactUs{background:url(/static/img/menu/contactUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myBookings{background:url(/static/img/menu/myItinerary.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myAccount{background:url(/static/img/menu/myAccount.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myFavorite{background:url(/static/img/menu/myCollection.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myCoupon{background: url(/static/img/account/myCoupon.png) no-repeat;background-size: 15px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-signOut{background:url(/static/img/menu/signOut.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .left-ment-setup{text-align:right;font-size:13px;}
  .right-menu .right-ment-setup{font-size:13px;}
  .right-menu .alert-left{overflow: hidden;white-space: nowrap;font-size: 15px;}
  .right-menu .alert-right{text-align:right; color:#4F4C4C;font-size: 15px;}
  .right-menu .alert-right img{width: 32px;height: 20px;margin: -3px 0px;}
  .right-menu-hr{border-bottom:dashed 1px rgba(79, 76, 76, 1);height: 20px;}
  .account-menu{font-size: 16px;height:50px; line-height:50px;width: 100%;}
  /* .el-menu-item span{color:rgba(0, 0, 0, 0.24705882352941178);} */
  .el-menu--horizontal .el-menu-item:not(.is-disable):hover{color:rgba(83, 102, 163, 1);background-color:rgba(242, 242, 242, 1);}
  /deep/ .el-menu--popup{ min-width: 100px !important;}
  .header-login{width: auto;margin-right: 15px; float: right;}
  .userItem{padding-bottom:5px;}
  .right-header /deep/ .el-submenu__title{ width: auto; padding: 0 !important;font-size: 14px !important; margin-left: 20px;}

  .alert-menu .header-link{color: black;text-decoration: none;}
  .alert-menu .right-menu-group{margin:0px 25px;}
  /deep/ .el-menu .is-disabled .el-submenu__title{color: black !important; opacity:1;}
  /deep/ .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border: none;}
  /deep/ .el-menu--horizontal .el-menu .el-menu-item.is-active,  /deep/ .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title{color: rgba(83, 102, 163, 1);}
  /deep/ .el-menu--popup{min-width: 120px;}
  .account-menu div{display: inline-block;}
  .balance-info{float: right;min-width: 200px;font-size:14px;width: auto;height: 60px;line-height: 60px;color: rgb(83, 102, 163); text-align: right;}
  /deep/ .el-icon-check{color: #333;}
  .el-menu--horizontal .el-menu-item:not(.is-disable):hover .el-icon-check {color:rgb(83, 102, 163); /* 将子元素的背景色设置为红色 */}
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  /deep/ .el-select-dropdown__item{padding: 0 15px;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color: rgba(83, 102, 163, 1) !important;}
  /deep/ .el-submenu__title * {vertical-align: unset;}
  .username {
    font-size: 14px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* display: inline-block; */
    max-width: 75%;
  }
  /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{border-bottom: none;}
  .home-header-button{display: block; margin: 0 auto; border: 1px solid #2A6FF8;border-radius: 9999px;width: 180px;height: 50px;line-height: 50px;text-align: center;font-weight: 500;}
</style>



// WEBPACK FOOTER //
// src/components/public/publicHomeHeader.vue